export default function LayoutConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('layout');
}

LayoutConfiguration.$inject = ['$translatePartialLoaderProvider'];
